import {
  faFileExport,
  faFilter,
  faPlus
} from '@fortawesome/free-solid-svg-icons';

import {
  faSquare,
} from '@fortawesome/free-regular-svg-icons';


//import { Clock, Target, Award, Calendar, TrendingUp, Users } from 'lucide-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import DatePicker from 'components/base/DatePicker';
import SearchBox from 'components/common/SearchBox';
import LeadsFilterModal from 'components/modals/LeadsFilterModal';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { useState, ChangeEvent, useEffect } from 'react';
import { Col, FloatingLabel, Offcanvas, Form, Row, Toast, ToastContainer, Card } from 'react-bootstrap';

import apiClient, { handleAPIError } from 'helpers/apiService';
import { useAuth } from 'providers/AuthProvider';
import { PromptData } from './components/DataDefinitions';
import { ColumnDef } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import RevealDropdown, { RevealDropdownTrigger } from 'components/base/RevealDropdown';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import { Dropdown } from 'react-bootstrap';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import Badge from 'components/base/Badge';


const breadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Dashboard',
    url: '/dashboard/home'
  },
  {
    label: 'Prompt Manager (Admin)',
    active: true
  }
];

const ActionDropdownItem = ({ prompt_id, onDelete }: {
  prompt_id: string | number,
  onDelete: (id: string | number) => void;
}) => {
  return (
    <>
      <Dropdown.Item eventKey="2" onClick={() => onDelete(prompt_id)} className="text-danger">
        Remove
      </Dropdown.Item>
    </>
  );
};

const PromptTable = () => {
  return (
    <div className="border-top">
      <AdvanceTable
        tableProps={{ className: 'phoenix-table fs-9' }}
        rowClassName="hover-actions-trigger btn-reveal-trigger"
      />
      <AdvanceTableFooter pagination className="py-4" />
    </div>
  );
};



const Prompts = () => {
  const auth = useAuth();
  const [prompts, setPrompts] = useState<PromptData[]>([]);
  const [prompt, setPrompt] = useState<PromptData>({
    prompt_id: 0,
    prompt_name: '',
    context: '',
    question1: '',
    question2: '',
    question3: '',
    question4: '',
    inserted_at: '',
    enabled: false,
    page: '',
    icon_name: '',
    menu_order: 0,
    background_color: ''
  });

  // State to control Toast messages
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');


  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const [errors, setErrors] = useState<{ prompt_name?: string, context?: string, question1?: string }>({});

  const promptsTableColumns: ColumnDef<PromptData>[] = [
    {
      accessorKey: 'name',
      header: 'Name',
      cell: ({ row: { original } }) => {
        const { prompt_name } = original;


        return (
          <div className="d-flex align-items-center">
            <Link to="#!" onClick={() => (setPrompt(original), setShow(true), console.log(original))} className="fw-semi-bold">
              {prompt_name}
            </Link>
          </div >
        );
      },
      meta: {
        headerProps: { style: { width: '30%' }, className: 'ps-0' },
        cellProps: { className: 'white-space-nowrap ps-0' }
      }
    },
    {
      accessorKey: 'page',
      header: 'Page',
      cell: ({ row: { original } }) => original.page,
      meta: {
        headerProps: {
          style: { width: '15%' },
          className: 'ps-4 pe-5'
        },
        cellProps: {
          className: 'white-space-nowrap ps-4 text-700'
        }
      }
    },
    {
      accessorKey: 'enabled',
      header: 'Enabled',
      cell: ({ row: { original } }) => {
        return (
          <Badge variant="phoenix" bg={original.enabled ? 'success' : 'warning'}>
            {original.enabled ? 'On' : 'Off'}
          </Badge>
        );
      },
      meta: {
        headerProps: { style: { width: '7%' }, className: 'ps-0 align-content-center' },
        cellProps: { className: 'white-space-nowrap ps-0' }
      }
    },
    {
      accessorKey: 'iconName',
      header: 'Icon Name',
      cell: ({ row: { original } }) => original.icon_name,
      meta: {
        headerProps: { style: { width: '7%' }, className: 'ps-0' },
        cellProps: { className: 'white-space-nowrap ps-0' }
      }
    },
    {
      accessorKey: 'order',
      header: 'Menu order',
      cell: ({ row: { original } }) => original.menu_order,
      meta: {
        headerProps: { style: { width: '7%' }, className: 'ps-0' },
        cellProps: { className: 'white-space-nowrap ps-0' }
      }
    },
    {
      accessorKey: 'inserted_at',
      header: 'Create date',
      cell: ({ row: { original } }) => original.inserted_at,
      meta: {
        headerProps: {
          style: { width: '15%' },
          className: 'ps-4 pe-5'
        },
        cellProps: {
          className: 'white-space-nowrap ps-4 text-700'
        }
      }
    },
    {
      id: 'contactDropdown',
      cell: ({ row: { original } }) => {
        return (
          <RevealDropdownTrigger>
            <RevealDropdown>
              <ActionDropdownItem prompt_id={original.prompt_id} onDelete={deletePrompt} />
            </RevealDropdown>
          </RevealDropdownTrigger>
        );
      },
      meta: {
        cellProps: {
          className: 'text-end pe-0 ps-4'
        }
      }
    }
  ];

  const fetchData = async () => {
    const { data } = await apiClient.get('/v1/admin/prompts');
    setPrompts(data);
  };

  useEffect(() => {
    fetchData();
  }, []);


  const table = useAdvanceTable({
    data: prompts,
    columns: promptsTableColumns,
    pageSize: 5,
    pagination: true,
    sortable: true,
    selection: true,
    initialState: {
      columnVisibility: {
        status: false,
        designation: false
      }
    }
  });

  // Function to handle input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPrompt({ ...prompt, [name]: value });
  };

  const handleCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    setPrompt({ ...prompt, [name]: checked });
  };

  const [openFilterModal, setOpenFilterModal] = useState(false);
  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    table.setGlobalFilter(e.target.value || undefined);
  };


  const handleClick = () => {

    setPrompt({
      prompt_id: 0,
      prompt_name: '',
      context: '',
      question1: '',
      question2: '',
      question3: '',
      question4: '',
      inserted_at: '',
      enabled: false,
      page: '',
      icon_name: '',
      menu_order: 0,
      background_color: ''
    });
    setShow(true);
  };

  // Validation function for Form 1
  const validateForm1 = (): boolean => {
    const newErrors: { prompt_name?: string, context?: string, question1?: string } = {};
    let isValid = true;

    if (!prompt.prompt_name) {
      newErrors.prompt_name = 'Prompt Name required';
      isValid = false;
    }

    if (!prompt.context) {
      newErrors.context = 'Context required';
      isValid = false;
    }

    if (!prompt.question1) {
      newErrors.question1 = 'At least question 1 is required';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async () => {

    if (validateForm1() == false) {
      return
    }
    const formData = new FormData();
    formData.append('promptForm', JSON.stringify(prompt));
    try {

      if (prompt.prompt_id == 0) {
        const response = await apiClient.post(
          `/v1/prompts/new`, formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',

            }
          }
        );
        setToastMessage(response.data['message'])
      } else {
        const response = await apiClient.put(
          `/v1/prompts/${prompt.prompt_id}`, formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',

            }
          }
        );
        setToastMessage(response.data['message'])
      }
      fetchData();
      setShowToast(true);
      setShow(false);
    } catch (error) {
      console.error('Request failed:', error);
      setToastMessage("Unable to save data to the database");
    }

  };

  const deletePrompt = async (id: string | number) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      const response = await apiClient.delete(
        `/v1/prompts/${id}`,
        {
          headers: {
            'accept': 'application/json',

          }
        }
      );
      setToastMessage(response.data['message'])
      setShowToast(true);
      fetchData();
    }
  };

  return (
    <>
      <PageBreadcrumb items={breadcrumbItems} />

      <Offcanvas show={show} onHide={handleClose} backdrop="static" placement="end" style={{ 'width': '35%' }}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className='fs-5' >Prompt Setup</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>

          <Form className='d-grid gap-3'>
            <FloatingLabel controlId="prompt_name" label="prompt name *">
              <Form.Control as="textarea" rows={3} placeholder="prompt name" style={{ height: '100%' }} required
                name='prompt_name' value={prompt.prompt_name} onChange={handleInputChange}
                isInvalid={!!errors.prompt_name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.prompt_name}
              </Form.Control.Feedback>
            </FloatingLabel>

            <Form.Group controlId="context" className="mb-3">
              <Form.Label>context *</Form.Label>
              <Form.Control as="textarea" rows={15} placeholder="context" style={{ height: '100%' }} required
                name='context' value={prompt.context} onChange={handleInputChange}
                isInvalid={!!errors.context}
              />
              <Form.Control.Feedback type="invalid">
                {errors.context}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="question1" className="mb-3">
              <Form.Label>Question 1 *</Form.Label>

              <Form.Control as="textarea" rows={4} placeholder="Question 1" style={{ height: '100%' }} required
                name='question1' value={prompt.question1} onChange={handleInputChange}
                isInvalid={!!errors.question1}
              />
              <Form.Control.Feedback type="invalid">
                {errors.question1}
              </Form.Control.Feedback>

            </Form.Group>

            <Form.Group controlId="question2" className="mb-3">
              <Form.Label>Question 2</Form.Label>

              <Form.Control as="textarea" rows={4} placeholder="Question 2" style={{ height: '100%' }}
                name='question2' value={prompt.question2} onChange={handleInputChange}
              />
            </Form.Group>

            <Form.Group controlId="question3" className="mb-3">
              <Form.Label>Question 3</Form.Label>

              <Form.Control as="textarea" rows={4} placeholder="Question 3" style={{ height: '100%' }}
                name='question3' value={prompt.question3} onChange={handleInputChange}
              />
            </Form.Group>

            <Form.Group controlId="question4" className="mb-3">
              <Form.Label>Question 4</Form.Label>

              <Form.Control as="textarea" rows={4} placeholder="Question 4" style={{ height: '100%' }}
                name='question4' value={prompt.question4} onChange={handleInputChange}
              />
            </Form.Group>

            <FloatingLabel controlId="page" label="page">
              <Form.Control as="select" placeholder="page"
                name='page' value={prompt.page} onChange={handleInputChange} >
                <option >Select one</option>
                <option value="api">API</option>
                <option value="main_dashboard">Main Dashboard</option>
                <option value="meetings">Meetings</option>
                <option value="learning">My Learning</option>
                <option value="feedback">My Feedback</option>
                <option value="skills">Skills</option>
              </Form.Control>
            </FloatingLabel>

            <FloatingLabel controlId="iconName" label="iconName">
              <Form.Control as="select" placeholder="iconName"
                name='icon_name' value={prompt.icon_name} onChange={handleInputChange} >
                <option >Select the icon</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
              </Form.Control>
            </FloatingLabel>

            <Form.Group controlId="order" className="mb-3">
              <Form.Label>Order</Form.Label>

              <Form.Control as="text" placeholder="Prompt order (0..10)" style={{ height: '100%' }}
                name='menu_order' value={prompt.menu_order} onChange={handleInputChange}
              />
            </Form.Group>


            <FloatingLabel controlId="bg_color" label="Prompt background">
              <Form.Control as="select" placeholder="Prompt background"
                name='background_color' value={prompt.background_color} onChange={handleInputChange} >
                <option >Select the background</option>
                <option value="" className=''>no background</option>
                <option value="bg-soft-primary " className="bg-soft-primary ">bg-soft-primary </option>
                <option value="bg-soft-secondary " className="bg-soft-secondary ">bg-soft-secondary </option>
                <option value="bg-soft-success " className="bg-soft-success ">bg-soft-success </option>
                <option value="bg-soft-info " className="bg-soft-info ">bg-soft-info </option>
                <option value="bg-soft-warning " className="bg-soft-warning ">bg-soft-warning </option>
                <option value="bg-soft-danger " className="bg-soft-danger ">bg-soft-danger </option>
                <option value="bg-light-primary " className="bg-light-primary ">bg-light-primary </option>
                <option value="bg-light-secondary " className="bg-light-secondary ">bg-light-secondary </option>
                <option value="bg-light-success " className="bg-light-success ">bg-light-success </option>
                <option value="bg-light-info " className="bg-light-info ">bg-light-info </option>
                <option value="bg-light-warning " className="bg-light-warning ">bg-light-warning </option>
                <option value="bg-light-danger " className="bg-light-danger ">bg-light-danger </option>
                <option value="bg-theachai-red " className="bg-theachai-red ">bg-theachai-red </option>
                <option value="bg-theachai-yellow " className="bg-theachai-yellow ">bg-theachai-yellow </option>
                <option value="bg-theachai-chardonnay " className="bg-theachai-chardonnay ">bg-theachai-chardonnay </option>
                <option value="bg-theachai-tiffany " className="bg-theachai-tiffany ">bg-theachai-tiffany </option>
                <option value="bg-theachai-dark-blue " className="bg-theachai-dark-blue ">bg-theachai-dark-blue </option>
                <option value="bg-theachai-gray " className="bg-theachai-gray ">bg-theachai-gray </option>

              </Form.Control>
            </FloatingLabel>
            <Form.Check
              type="checkbox"
              id="enabled"
              name="enabled"
              label="enabled"
              checked={prompt.enabled}
              onChange={handleCheckChange}
            />

            <Button
              variant="primary"
              onClick={handleSubmit}
            >
              Save
            </Button>
          </Form>

        </Offcanvas.Body>
      </Offcanvas>

      <ToastContainer className="p-3" position='top-center'>
        <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide>
          <Toast.Body className=''>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      <Card className='mt-3  mb-3 border border-light rounded-5' >
        <Card.Body>
          <AdvanceTableProvider {...table}>
            <Row className="g-3 justify-content-between mb-4">
              <Col xs="auto">
                <Button
                  variant="primary"
                  className="me-4"
                  startIcon={<FontAwesomeIcon icon={faPlus} className="me-2" />}
                  onClick={handleClick}
                >
                  Create
                </Button>
                <Button
                  variant="link"
                  className="text-900 px-0"
                  startIcon={
                    <FontAwesomeIcon icon={faFileExport} className="fs-9 me-2" />
                  }
                >
                  Export
                </Button>
              </Col>
              <Col xs="auto">
                <div className="d-flex">
                  <SearchBox
                    placeholder="Search by name"
                    className="me-2"
                    onChange={handleSearchInputChange}
                  />
                  <DatePicker defaultValue="Mar 1, 2022" />
                  <Button
                    variant="phoenix-secondary"
                    className="px-3 ms-2"
                    onClick={() => setOpenFilterModal(true)}
                  >
                    <FontAwesomeIcon
                      icon={faFilter}
                      transform="down-3"
                      className="text-primary"
                    />
                  </Button>
                </div>
                <LeadsFilterModal
                  show={openFilterModal}
                  handleClose={() => setOpenFilterModal(false)}
                />
              </Col>
            </Row>
            <PromptTable />
          </AdvanceTableProvider>
        </Card.Body>
      </Card>
    </>
  );
};

export default Prompts;